module.exports = __webpack_public_path__ + "img/default-video-cover.d20448e5.jpg";